import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.less']
})
export class SpinnerComponent implements OnInit {

  showSpinner: boolean = false;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngOnInit(): void {
  }

}
